import { CampaignPopup } from '@definitions/types/storyblokTypes'

/**
 * Parses Storyblok campaign popup story content and validates it
 * @param storyContent - The content object from Storyblok story (CampaignPopup type)
 * @returns CampaignPopup or null if invalid or inactive
 */
export function parseCampaignPopup(
  storyContent: Partial<CampaignPopup> | null | undefined
): CampaignPopup | null {
  if (!storyContent) {
    return null
  }

  if (storyContent.active !== true || !storyContent.content || typeof storyContent.content !== 'object' || storyContent.content === null) {
    return null
  }

  return {
    active: storyContent.active,
    content: storyContent.content,
    start_date: storyContent.start_date ?? undefined,
    end_date: storyContent.end_date ?? undefined,
  } as CampaignPopup
}
